/**
 * Determine whether a value is a primitive. Primitive values are
 * string, number, boolean, null, undefined. Basically anything but object &
 * function.
 */
export default function isPrimitive(val) {
    if (val == null) {
        return true;
    }
    var valType = typeof val;
    return valType !== 'object' && valType !== 'function';
}
